const template = document.createElement('template');
template.innerHTML = `
<style>
  :host {
    margin-top: auto;
    position: sticky;
    bottom: 0;
    position: -webkit-sticky; /* safari support */
    display: block;
  }

  .personalisation-navigation-buttons {
    background: var(--White, #FFF);
    box-shadow: 0rem 0.1038rem 0.505rem 0rem rgba(17, 17, 17, 0.03), 0rem 0.2494rem 1.2136rem 0rem rgba(17, 17, 17, 0.04), 0rem 0.4696rem 2.2852rem 0rem rgba(17, 17, 17, 0.05), 0rem 0.8376rem 4.0764rem 0rem rgba(17, 17, 17, 0.05);
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 1.25rem 2.5rem;
    margin: 0 -2.5rem -2.5rem;
  }

  .personalisation-navigation-buttons.show-confirm .button.next-button {
    display: none;
  }

  .personalisation-navigation-buttons.show-confirm .button.confirm-button,
  .personalisation-navigation-buttons.show-previous .button.previous-button {
    display: flex;
  }

  .personalisation-navigation-buttons.show-confirm.show-previous .confirm-button {
    width: calc(100% - 3rem);
  }

  .hidden.previous-button {
    display: none;
  }

  .previous-button.hidden + .button.next-button {
    width: 100% !important;
  }

  .button {
    border-radius: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-transform: uppercase;
  }

  .button svg {
    width: 0.7813rem;
    height: 0.7813rem;
  }

  .button.previous-button {
    display: none;
    border: 0.0625rem solid var(--transparent-navy-navy-12);
    background-color: transparent;
    width: 2.5rem;
    height: 2.5rem;
  }

  .button.confirm-button {
    display: none;
  }

  .button.confirm-button,
  .button.next-button {
    background-color: var(--opaque-lark-navy);
    border: none;
    padding: 0.75rem 1.5rem;
    color: var(--color-white);
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 2.16px;
    width: 100%;
  }

  @media screen and (max-width: 1099px) {
    :host {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
    .personalisation-navigation-buttons {
      margin: 0 0;
      padding: 1.25rem;
    }
  }

  @media screen and (min-width: 1100px) {
    :host {
      position: absolute;
      bottom: 0;
      right: 0;
      max-width: 32.5rem;
      width: 100%;
    }

    .personalisation-navigation-buttons {
      margin: 0;
    }
  }
</style>

<div class="personalisation-navigation-buttons" part="navigation">
  <button class="button previous-button">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><path stroke="#123247" stroke-linecap="square" stroke-linejoin="round" d="M12.208 7H2.313"/><path stroke="#123247" stroke-linecap="square" d="M4.396 9.604 1.792 7l2.604-2.604"/></svg>
  </button>
  <button class="button next-button" data-product-form-add>Continue</button>
  <button class="button confirm-button" data-product-form-add>Add to Cart —&nbsp; <span data-product-form-price></span></button>
</div>
`;

export class PersonalisationNavigationButtons extends HTMLElement {
  private readonly root: HTMLDivElement | null;
  private prevButton: HTMLButtonElement | null;
  private nextButton: HTMLButtonElement | null;
  private confirmButton: HTMLButtonElement | null;
  private priceElement: HTMLElement | null;
  private price:any;

  constructor() {
    super();
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.root = shadowRoot.querySelector('.personalisation-navigation-buttons')!;
    this.prevButton = this.root.querySelector('.previous-button');
    this.nextButton = this.root.querySelector('.next-button');
    this.confirmButton = this.root.querySelector('.confirm-button');
    this.priceElement = this.root.querySelector('[data-product-form-price]');
    this.price = this.getAttribute('data-price') || '';

    if(this.priceElement) this.priceElement.innerText = ` ${this.price}`;

    this.prevButton?.addEventListener('click', this.handlePrevButton);
    this.nextButton?.addEventListener('click', this.handleNextButton);

    if(this.getAttribute('data-cart-edit') !== null) {
      this.confirmButton?.addEventListener('click', this.handleEditToCart);
    }
    else {
      this.confirmButton?.addEventListener('click', this.handleAddToCart);
    }
  }

  handlePrevButton() {
    this.dispatchEvent(new CustomEvent('navigation', {
      detail: { pageIndex: -1, fromButton: true },
      bubbles: true,
      composed: true
    }));
  }

  handleNextButton() {
    this.dispatchEvent(new CustomEvent('navigation', {
      detail: { pageIndex: 1, fromButton: true },
      bubbles: true,
      composed: true
    }));
  }

  private handleAddToCart() {
    const event = new CustomEvent('add_to_cart', { 
      detail: {}, 
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }

  private handleEditToCart() {
    const event = new CustomEvent('edit_cart', { 
      detail: {}, 
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }

  setActive(currentPage:number, lastPageIndex:number) {
    this.root!.classList[currentPage > 0 ? 'add' : 'remove']('show-previous');
    this.root!.classList[currentPage === lastPageIndex ? 'add' : 'remove']('show-confirm');
  }
}

if(!customElements.get('personalisation-navigation-buttons')) {
  customElements.define('personalisation-navigation-buttons', PersonalisationNavigationButtons);
}